import styled from 'styled-components';

export const AssessmentWrapper = styled.div`
  width: 100%;

  strong {
    font-weight: 600 !important;
  }
`;
